module.exports = __webpack_public_path__ + "media/application/images/2023/07_still-1920x1080-8edbd5fc650ad5da5ce2a3dbc13287c1.png";